export default "__VITE_ASSET__Cqb9swQj__"